import { HeartIcon } from '@phosphor-icons/react';
import { HotelDetailsHeaderButton } from './hotel_details_header_button.js';

/** O coração no cabeçalho da gaveta (item 1 F2) — presentational como o resto
 *  do painel: estado (`pressed`), rótulos por estado e callback vêm do host;
 *  nenhum IO aqui. Ausente ⇒ o cabeçalho fica só com o fechar, como sempre. */
export type HotelDetailsFavorite = {
  pressed: boolean;
  markLabel: string;
  unmarkLabel: string;
  onToggle(): void;
};

/** O coração da gaveta, par do fechar no cabeçalho: `aria-pressed` carrega o
 *  estado e o rótulo diz a AÇÃO do próximo clique — a mesma gramática do
 *  coração do card (`HotelFavoriteButton`, hotel_offer_card.tsx). `disabled`
 *  reflete o `busy` do painel: sem ele, um segundo clique enquanto a mutação
 *  anterior ainda voa dispararia mark/unmark fora de ordem. */
export function HotelDetailsFavoriteButton({
  favorite,
  disabled = false,
  size = 'icon-sm',
}: {
  readonly favorite: HotelDetailsFavorite;
  readonly disabled?: boolean;
  /** `icon-lg` na página, par do "Ver quartos" (h-9); a gaveta segue no `icon-sm`. */
  readonly size?: 'icon-sm' | 'icon-lg';
}) {
  return (
    <HotelDetailsHeaderButton
      label={favorite.pressed ? favorite.unmarkLabel : favorite.markLabel}
      className="hui-hotel-details-favorite"
      size={size}
      pressed={favorite.pressed}
      disabled={disabled}
      onClick={() => {
        favorite.onToggle();
      }}
    >
      <HeartIcon aria-hidden="true" weight={favorite.pressed ? 'fill' : 'regular'} />
    </HotelDetailsHeaderButton>
  );
}
